// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"fa283286","642":"9811c8c4","713":"726f8053"}[chunkId] + ".chunk.js";
};